(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alpha-home-editorial-2026"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ahe-tabs]').forEach((tabs) => {
    const buttons = tabs.querySelectorAll('[data-ahe-tab]');
    const panels = tabs.querySelectorAll('[data-ahe-panel]');
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const group = button.dataset.aheTab;
        buttons.forEach((item) => item.setAttribute('aria-selected', String(item === button)));
        panels.forEach((panel) => { panel.hidden = panel.dataset.ahePanel !== group; });
      });
    });
  });
  document.querySelectorAll('.ahe__nav-drop').forEach((menu) => {
    menu.addEventListener('toggle', () => {
      if (!menu.open) return;
      document.querySelectorAll('.ahe__nav-drop').forEach((other) => {
        if (other !== menu) other.removeAttribute('open');
      });
    });
  });
  document.addEventListener('click', (event) => {
    if (event.target.closest('.ahe__nav-drop')) return;
    document.querySelectorAll('.ahe__nav-drop[open]').forEach((menu) => menu.removeAttribute('open'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alpha-quality-tabs-2026"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (scope) => {
      scope.querySelectorAll('[data-alpha-quality-tabs]').forEach((root) => {
        if (root.dataset.aqtReady === 'true') return;
        root.dataset.aqtReady = 'true';

        const relocationTarget = root.dataset.relocateTarget;
        if (relocationTarget) {
          const target = document.querySelector(relocationTarget);
          const wrapper = root.closest('.shopify-section') || root;
          if (target && !target.contains(root)) target.replaceWith(wrapper);
        }

        const tabs = Array.from(root.querySelectorAll('.aqt__tabs > [data-aqt-tab]'));
        const panels = Array.from(root.querySelectorAll('.aqt__panels > [data-aqt-panel]'));
        const standardContent = root.querySelector('[data-aqt-standard-content]');
        const floatingContent = root.querySelector('[data-aqt-floating-content]');
        const configurator = document.querySelector('[data-aap-root]');
        const syncFloatingContent = () => {
          if (!standardContent || !floatingContent) return;

          const activeSupport = configurator?.querySelector('[data-aap-supports] button[data-support][aria-pressed="true"]')
            || configurator?.querySelector('[data-aap-supports] button[data-support].is-active');
          const floatingSelected = activeSupport?.dataset.support === 'framed-canvas';

          standardContent.hidden = floatingSelected;
          floatingContent.hidden = !floatingSelected;
          root.classList.toggle('aqt--floating-selected', floatingSelected);

          floatingContent.querySelectorAll('video').forEach((video) => {
            if (floatingSelected && video.dataset.aqtVideoReady !== 'true') {
              video.dataset.aqtVideoReady = 'true';
              video.preload = 'metadata';
              video.load();
            }
            if (!floatingSelected && !video.paused) video.pause();
          });
        };

        if (configurator) {
          const configuratorObserver = new MutationObserver(() => {
            if (!root.isConnected) {
              configuratorObserver.disconnect();
              return;
            }
            syncFloatingContent();
          });
          configuratorObserver.observe(configurator, {
            attributes: true,
            attributeFilter: ['aria-pressed', 'class'],
            childList: true,
            subtree: true
          });
        }
        syncFloatingContent();
        const loadDigitalPreview = () => {
          const image = root.querySelector('[data-aqt-external-art]');
          if (!image || image.dataset.aqtLoaded === 'true') return;

          const configurator = document.querySelector('[data-aap-root]');
          const sourceUrl = configurator?.dataset.aapDigitalPreview || configurator?.dataset.aapSourceUrl;
          if (!sourceUrl) return;

          try {
            const source = new URL(sourceUrl, document.baseURI);
            if (source.protocol !== 'https:' && source.protocol !== 'http:') return;

            const sourceWidth = Number.parseInt(configurator.dataset.aapSourceWidth, 10);
            const sourceHeight = Number.parseInt(configurator.dataset.aapSourceHeight, 10);
            if (Number.isFinite(sourceWidth) && sourceWidth > 0) image.width = sourceWidth;
            if (Number.isFinite(sourceHeight) && sourceHeight > 0) image.height = sourceHeight;

            const fallback = root.querySelector('[data-aqt-digital-fallback]');
            image.addEventListener('load', () => {
              image.hidden = false;
              if (fallback) fallback.hidden = true;
            }, { once: true });
            image.addEventListener('error', () => {
              image.hidden = true;
              if (fallback) fallback.hidden = false;
            }, { once: true });
            image.dataset.aqtLoaded = 'true';
            image.src = source.href;
          } catch (error) {
            image.dataset.aqtLoaded = 'false';
          }
        };
        const activate = (tab, moveFocus = false) => {
          const key = tab.dataset.aqtTab;
          tabs.forEach((item) => {
            const active = item === tab;
            item.setAttribute('aria-selected', active ? 'true' : 'false');
            item.tabIndex = active ? 0 : -1;
          });
          panels.forEach((panel) => { panel.hidden = panel.dataset.aqtPanel !== key; });
          if (key === 'digital') loadDigitalPreview();
          if (moveFocus) tab.focus();
        };

        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => activate(tab));
          tab.addEventListener('keydown', (event) => {
            let nextIndex = null;
            if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = tabs.length - 1;
            if (nextIndex === null) return;
            event.preventDefault();
            activate(tabs[nextIndex], true);
          });
        });

        root.querySelectorAll('[data-aqt-option-tabs]').forEach((group) => {
          const optionTabs = Array.from(group.querySelectorAll('[data-aqt-option-tab]'));
          const media = group.closest('.aqt__media');
          const optionPanels = media ? Array.from(media.querySelectorAll('[data-aqt-option-panel]')) : [];
          const activateOption = (tab, moveFocus = false) => {
            const key = tab.dataset.aqtOptionTab;
            optionTabs.forEach((item) => {
              const active = item === tab;
              item.setAttribute('aria-selected', active ? 'true' : 'false');
              item.tabIndex = active ? 0 : -1;
            });
            optionPanels.forEach((panel) => { panel.hidden = panel.dataset.aqtOptionPanel !== key; });
            group.closest('[data-aqt-panel]').querySelectorAll('[data-aqt-detail]').forEach((detail) => {
              detail.hidden = detail.dataset.aqtDetail !== key;
            });
            if (moveFocus) tab.focus();
          };

          optionTabs.forEach((tab, index) => {
            tab.addEventListener('click', () => activateOption(tab));
            tab.addEventListener('keydown', (event) => {
              let nextIndex = null;
              if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % optionTabs.length;
              if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + optionTabs.length) % optionTabs.length;
              if (event.key === 'Home') nextIndex = 0;
              if (event.key === 'End') nextIndex = optionTabs.length - 1;
              if (nextIndex === null) return;
              event.preventDefault();
              activateOption(optionTabs[nextIndex], true);
            });
          });
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialise(document));
    } else {
      initialise(document);
    }
    document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
